import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import apiClient from "../lib/api";
import { API } from "../lib/api";
import { useAuth } from "../contexts/AuthContext";
import { useI18n } from "../i18n";
import { Download } from "lucide-react";
import { toast } from "sonner";

const Account = () => {
  const { user, logout } = useAuth();
  const { t, lang } = useI18n();
  const [orders, setOrders] = useState([]);

  useEffect(() => { apiClient.get("/orders/mine").then((r) => setOrders(r.data)).catch(() => setOrders([])); }, []);

  const downloadInvoice = async (orderId) => {
    try {
      const token = localStorage.getItem("auth_token");
      const res = await fetch(`${API}/orders/${orderId}/invoice`, { headers: { Authorization: `Bearer ${token}` } });
      if (!res.ok) {
        const err = await res.json().catch(() => ({}));
        throw new Error(err.detail || "Failed");
      }
      const blob = await res.blob();
      const url = URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = `invoice-${orderId}.pdf`;
      document.body.appendChild(a);
      a.click();
      a.remove();
      URL.revokeObjectURL(url);
    } catch (e) {
      toast.error(e.message || (lang === "nl" ? "Download mislukt" : "Download failed"));
    }
  };

  return (
    <div className="max-w-[1200px] mx-auto px-6 lg:px-12 py-10" data-testid="account-page">
      <div className="flex items-end justify-between border-b border-black/10 pb-6 mb-10">
        <div>
          <div className="font-label text-ink-muted">{user?.email}</div>
          <h1 className="font-display text-5xl tracking-tighter font-light mt-1">{lang === "nl" ? `Hallo, ${user?.name}` : `Hello, ${user?.name}`}</h1>
        </div>
        <button onClick={logout} className="btn-secondary text-xs">{t("nav_logout")}</button>
      </div>

      <h2 className="font-display text-2xl mb-4">{t("orders")}</h2>
      {orders.length === 0 ? (
        <div className="text-ink-muted">{lang === "nl" ? "Nog geen bestellingen." : "No orders yet."} <Link to="/shop" className="underline ml-2">{t("nav_shop")}</Link></div>
      ) : (
        <div className="border border-black/10 divide-y divide-black/10">
          {orders.map((o) => (
            <div key={o.order_id} className="p-4 flex items-center justify-between flex-wrap gap-3" data-testid={`order-row-${o.order_id}`}>
              <div>
                <div className="font-display">{o.order_id}{o.invoice_number && <span className="text-xs text-ink-muted ml-2">· {o.invoice_number}</span>}</div>
                <div className="text-xs text-ink-muted">{o.created_at?.slice(0, 10)} · {o.lines.length} items · €{o.grand_total.toFixed(2)}</div>
              </div>
              <div className="flex items-center gap-2 flex-wrap">
                <span className="font-label text-xs">{o.status}</span>
                {o.payment_status === "paid" && (
                  <button onClick={() => downloadInvoice(o.order_id)} data-testid={`download-invoice-${o.order_id}`} className="btn-secondary text-xs py-2 px-3"><Download className="w-3.5 h-3.5" /> {lang === "nl" ? "Factuur" : "Invoice"}</button>
                )}
                <Link to={`/track?code=${o.tracking_code}`} className="btn-secondary text-xs py-2 px-3">{t("nav_track")}</Link>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default Account;
